export default {
    abilities: 'Habilidades',
    abilityOne: {
        title: 'Localizar u obtener información',
        desc: 'Estás en un nivel <strong> {0} </strong> de lectura, te invitamos a continuar ejercitando para mantener tu capacidad de compresión.'
    },
    abilityTwo: {
        title: 'Integrar e interpretar',
        desc: 'Estás en un nivel <strong> {0} </strong> de lectura, te invitamos a reforzar tu competencia lectora.'
    },
    abilityThree: {
        title: 'Reflexionar y valorar',
        desc: 'Estás en un nivel <strong> {0} </strong> de lectura, te invitamos a desarrollar y mejorar tu competencia lectora.'
    },
    abilityLocalizar: {
        green: '¡Lo estás haciendo increíble! Eres capaz de encontrar la información que necesitas hasta en el último rincón del mundo.',
        yellow: '¡Sigue el rastro! Tu habilidad para localizar información está en constante evolución. La perseverancia es la clave.',
        red: '¡Ánimo! Explora con más atención los detalles de las lecturas. Intenta ver la información desde otra perspectiva.'
    },
    abilityIntegrar: {
        green: '¡Eres una leyenda! En cada texto, descifras los secretos ocultos como un verdadero Sherlock.',
        yellow: '¡Sigue explorando! Cada lectura te acerca más a convertirte en un maestro o maestra de la lectura entre líneas.',
        red: '¡No te desanimes! Aunque enfrentas desafíos, estás en el camino correcto para desentrañar los misterios que ocultan los textos. ¡Sigue adelante con determinación!'
    },
    abilityReflexionar: {
        green: '¡Estás en el nivel superior! Tu capacidad para pensar críticamente y aplicar conocimientos externos es asombrosa.',
        yellow: '¡Sigue adelante, lector perspicaz! Vas mejorando tu capacidad de valorar las ideas más allá del texto.',
        red: '¡No te desanimes, buscador de significado! No ha sido un camino fácil, pero has tenido algunos aciertos con tus reflexiones. Te recomendamos abrir tu mente a más posibilidades.'
    },
    abilityLevels: ['inicial', 'intermedio', 'avanzado'],
    achievements: 'Logros',
    accumulated_items: 'Recompensas acumuladas',
    subtitle_accumulated_items: 'Acá encuentras los BeeCoins y XP obtenidos en tu aventura lectora.',
    answered_questions: 'Preguntas Contestadas',
    back_to_avatars: 'Volver a avatares',
    back_to_skins: 'Volver a skins',
    buy_this_avatar: 'Comprar este avatar',
    buy_this_skin: 'Comprar este skin',
    check_your_progress: 'Revisa tu progreso',
    correct_answers: 'Respuestas Correctas',
    cumulative_xp: 'Experiencia acumulada',
    edit_avatar: 'Editar <b>avatar</b>',
    edit_my_avatar: 'Editar mi avatar',
    edit_skin: 'Editar <b>Skin</b>',
    global_progress: 'Progreso global',
    global_progress_rank: [
        'Últimos 7 días',
        'Últimos 30 días',
        'Últimos 90 días'
    ],
    leave: 'Salir',
    level: 'Nivel',
    my_categories: 'Mis categorías',
    my_skins: 'Mis skins',
    points: 'Puntos',
    purchase_avatar_desc: 'Este es un avatar especial que puedes adquirir comprándolo con tus BeeCoins. Una vez que lo compres, estará disponible en <b>Avatares especiales</b>.',
    purchase_skin_desc: 'Este es un skin especial que puedes adquirir comprándolo con tus BeeCoins. Una vez que lo compres, estará disponible en <b>Skins especiales<b/>.',
    save_changes: 'Guardar cambios',
    special_avatar: 'Avatar especial',
    special_avatars: 'Avatares especiales',
    standard_avatars: 'Avatares estándar',
    special_skin: 'Skin especial',
    special_skins: 'Skins especiales',
    standard_skins: 'Skins estándar',
    you_have: 'Tienes',
    your_collection: 'Tu colección',
    your_favorite_books: 'Tus libros favoritos',
    your_favorite_books_desc: 'Revisa los libros que seleccionaste como imperdibles en tu colección.',
    your_profile: 'Tu perfil',
    menu_edit_tooltip: 'Aquí podrás modificar tu avatar, tu skin y tus categorías favoritas.',
    student_code: 'Tu código',
    student_code_message: 'Código copiado en el portapapeles',
    understood: 'Entendido',
}
